import { render, staticRenderFns } from "./AddSubscriptionOrderAction.vue?vue&type=template&id=55be5f83"
import script from "./AddSubscriptionOrderAction.vue?vue&type=script&lang=js"
export * from "./AddSubscriptionOrderAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports